export function SystemVisual() {
	const tracks = [
		{ label: 'Gestionar el encargo sin equipo', progress: 0.72 },
		{ label: 'Fases del proyecto arquitectónico', progress: 0.48 },
		{ label: 'CTE-DB-HE · envolvente', progress: 0.28 },
		{ label: 'Presupuesto y mediciones', progress: 0.9 },
	]
	const rowHeight = 44
	const chartLeft = 240
	const chartRight = 488
	const chartWidth = chartRight - chartLeft
	const firstRowY = 96

	return (
		<svg
			viewBox="0 0 560 420"
			className="h-full w-full"
			role="img"
			aria-label="Sistema de aprendizaje: panel con rutas en progreso paralelo"
			style={{ color: 'var(--gold-text)' }}
		>
			<text
				x="280"
				y="30"
				textAnchor="middle"
				fontSize="12"
				fill="rgba(255,255,255,0.42)"
				fontFamily="ui-monospace, SFMono-Regular, monospace"
				letterSpacing="2"
			>
				PANEL · APRENDIZAJE EN CURSO
			</text>

			{tracks.map((track, index) => {
				const rowY = firstRowY + index * rowHeight
				const barWidth = chartWidth * track.progress

				return (
					<g key={track.label}>
						<text
							x="46"
							y={rowY + 12}
							fontSize="12"
							fill="rgba(255,255,255,0.72)"
						>
							{track.label}
						</text>
						<rect
							x={chartLeft}
							y={rowY + 5}
							width={chartWidth}
							height="5"
							rx="2.5"
							fill="rgba(255,255,255,0.05)"
						/>
						<rect
							x={chartLeft}
							y={rowY + 5}
							width="0"
							height="5"
							rx="2.5"
							fill="currentColor"
							fillOpacity="0.4"
						>
							<animate
								attributeName="width"
								from="0"
								to={String(barWidth)}
								dur={`${1.2 + index * 0.22}s`}
								fill="freeze"
							/>
						</rect>
						<circle
							cx={chartLeft + barWidth}
							cy={rowY + 7.5}
							r="2.5"
							fill="currentColor"
							fillOpacity="0.8"
						>
							<animate
								attributeName="r"
								values="2.5;3.5;2.5"
								dur={`${2 + index * 0.3}s`}
								repeatCount="indefinite"
							/>
						</circle>
						<text
							x={chartRight + 10}
							y={rowY + 11}
							fontSize="12"
							fill="rgba(255,255,255,0.48)"
							fontFamily="ui-monospace, SFMono-Regular, monospace"
						>
							{Math.round(track.progress * 100)}%
						</text>
					</g>
				)
			})}

			<line
				x1="46"
				y1="294"
				x2="514"
				y2="294"
				stroke="rgba(255,255,255,0.08)"
			/>
			<circle cx="52" cy="322" r="3.5" fill="currentColor" fillOpacity="0.7">
				<animate
					attributeName="fillOpacity"
					values="0.3;0.9;0.3"
					dur="2s"
					repeatCount="indefinite"
				/>
			</circle>
			<text
				x="66"
				y="318"
				fontSize="11"
				fill="rgba(255,255,255,0.42)"
				fontFamily="ui-monospace, SFMono-Regular, monospace"
				letterSpacing="2"
			>
				PRÓXIMO PASO
			</text>
			<text x="66" y="340" fontSize="13" fill="rgba(255,255,255,0.82)">
				Retomar «Fases del proyecto arquitectónico» · Tema 4 de 6
			</text>

			<text
				x="280"
				y="398"
				textAnchor="middle"
				fontSize="12"
				fill="rgba(255,255,255,0.38)"
			>
				4 rutas abiertas · progreso propio por cada una
			</text>
		</svg>
	)
}
